<template>
  <div class="wrapper">
        <forum-header v-if="isForum"></forum-header>
        <v-header v-else :account="account" :user="user"></v-header>
        <div class="bk-content" v-bkloading="{isLoading: globalState}">
            <router-view :account="account" :user="user" @openInformationPopup="openInformationPopup"></router-view>
            <transition name='fade'>
                <getMedalPop v-if="isShowNeedPop" :isNeedPopData.sync="isNeedPopData" :isShowNeedPop.sync="isShowNeedPop"></getMedalPop>
            </transition>
            <section class="qd-fixed-wrapper">
                <ul class="operate-wrapper">
                    <li class="operate-btn" @click="skip('https://bk.tencent.com/docs/')">
                        <i class="icon-help"></i>
                        <p style="width: 30px;">文档中心</p>
                    </li>
                    <li class="operate-btn" @click="onFeedback">
                        <i style="font-size: 16px" class="icon-comment"></i>
                        <p style="width: 30px;">社区提问</p>
                    </li>
                    <li class="operate-btn" @click="skip('https://admin.qidian.qq.com/template/blue/mp/menu/qr-code-jump-market.html?linkType=0&env=ol&kfuin=3009071079&fid=1082&key=37bdc52f7d2e4d5684a3dfcb16dd7b88&cate=1&source=&isLBS=&isCustomEntry=&type=16&ftype=1&_type=wpa&qidian=true')">
                        <i class="doc-icon icon-qq-i"></i>
                        <p style="width: 30px;">在线咨询</p>
                    </li>
                    <li class="operate-btn">
                        <el-popover placement="left" trigger="hover" popper-class="public-pop">
                            <div slot="reference">
                              <i class="icon-qr-code"></i>
                              <p>公众号</p>
                            </div>
                            <div>
                                <img class="qr-code" src="./images/video/Qr_code.png" alt="">
                                <p>扫码关注</p>
                                <p>获取更多资讯</p>
                            </div>
                        </el-popover>
                    </li>
                </ul>
            </section>
        </div>
        <information v-if="isInformationPopup || isWxPopup" :information-popup="isInformationPopup" :wx-popup="isWxPopup" @closeInfoBox="closeInfoBox" :downloadNeed="downloadNeed" :storeUserInfo="storeUserInfo"></information>
        <v-footer></v-footer>
  </div>
</template>

<script type="text/javascript">
  import header from './views/header.vue';
  import forumHeader from './views/forumHeader.vue'
  import information from './views/information.vue'
  import footer from './views/footer.vue';
  import getMedalPop from './views/common/getMedalPop.vue';
  import bus from '@/js/bus.js';
  export default {
    components: {
      'v-header': header,
      'v-footer': footer,
       getMedalPop,
       forumHeader,
       information
    },
    data () {
      return {
        account: {
          bkb: 0
        },
        user: {
          uid: 0
        },
        isNeedPopData: {},
        isShowNeedPop: false,
        isForum: false,
        isInformationPopup: false, // 是否完善信息
        downloadNeed: {
            status: false,
            callbackUrl: ''
        }, // 下载需要完善信息状态
        isWxPopup: false // 是否关注社区
      }
    },
    watch: {
        async 'isLogin' (val) {
            if (val) {
                await this.isNeedPop();
                this.closeNeedPop();
            }
            this.judgeInformationComplete()
        },
        '$route' () {
          this.initHeader()
        }
    },
    computed: {
        globalState() {
            return this.$store.state.globalLoading;
        },
        isLogin () {
            return this.$store.state.isLogin;
        },
        storeUserInfo () {
            return this.$store.state.userInfo
        },
    },
    created () {
      bus.$on('openInformationPopup', (type, url) => {
          this.isInformationPopup = true;
          this.downloadNeed.status = type === 'downLoad';
          this.downloadNeed.url = url;
      });
      this.initHeader()
    },
    async mounted() {
        if (this.isLogin) {
            await this.isNeedPop();
            this.closeNeedPop();
        }
    },
    methods: {
        initHeader () {
          const { pathname } = window.location
          const defaultPath = ['communities', 'community', 'personal_center', 'vip', 'honor']
          this.isForum = defaultPath.some(path => {
            if (pathname.indexOf(path) > -1) {
              return true
            }
          })
        },
        async judgeInformationComplete () {
          const promiseArr = [
              axios.post(myUrl + 'profile/user/contact/'),
              axios.post(myUrl + 'profile/get_user_profile/')
          ];
          Promise.all(promiseArr).then(result => {
              const [resp1, resp2] = result;
              const { phone } = resp1.data.data;
              const { nickname, company = {} } = resp2.data.data;
              const isComplete = phone && nickname && company.name && company.server_node;
              this.$store.commit('updateInformationComplete', Boolean(isComplete));
          }).catch(e => {
              console.log(e);
          });
      },
        async isNeedPop () {
         await axios.get(myUrl + 'forum/person/is_need_pop/').then(res => {
            if (!res.data.result) return;
            this.isShowNeedPop = true;
            this.isNeedPopData = res.data.data;
            if (this.isShowNeedPop) {
                setTimeout (() => {
                    this.isShowNeedPop = false;
                },2000)
            }
        })
      },
      closeNeedPop () {
           axios.post(myUrl + 'forum/person/has_pop/');
      },
      openInformationPopup (url) {
        this.isInformationPopup = true
        this.downloadNeed.status = true
        this.downloadNeed.callbackUrl = url
      },
      // 跳转链接
      skip (url) {
          if (!url) return
          window.open(url, '_blank')
      },
      onFeedback () {
          // 校验信息是否完善
          if (!this.$store.state.informationComplete) {
              this.isInformationPopup = true;
              return;
          }
          this.skip('https://bk.tencent.com/s-mart/community/ask');
      },
      closeInfoBox () {
          this.isInformationPopup = false
          this.isWxPopup = false
          this.downloadNeed.status = false
          this.downloadNeed.downloadNeed = ''
      }
    }
    
  }
</script>

<style lang="scss">
  @import "scss/bk-ui/bk.scss";
  // @import "scss/icon/iconfont.css";
  @import 'scss/smart-icon/style.css';
  @import "scss/common.scss";
  @import "css/idangerous.swiper.css";
  .bk-container {
    min-height: calc(100% - 144px - 320px) !important;
  }
  .bk-selector-input {
    border-color: #e6e6e7 !important;
  }
  .selector-smart {
    border-color: #e6e6e7 !important;
    border-radius: 2px;
  }
  .bk-form .warning input {
    border-color: #ff6600 !important;
  }
  .bk-form .warning textarea {
    border-color: #ff6600 !important;
  }
  .bk-form-input, .bk-form-password, .bk-form-select, .bk-form-textarea {
    border-color: #e6e6e7 !important;
  }
  .bk-form-input,
  .bk-form-password,
  .bk-form-select,
  .bk-form-textarea {
    color: #4f515e;
  }
  .el-message {
    z-index: 100002 !important;
  }
  // 取消饿了么tab选中切换页面返回后的阴影取消
  .el-tabs__item:focus.is-active.is-focus:not(:active) {
    box-shadow: initial;
  }
  // 快捷退出提示
  .fullScreen-tips {
      position: fixed;
      top: 14px;
      left: 50%;
      z-index: 100002;
      margin-left: -180px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 360px;
      height: 50px;
      opacity: 0.6;
      background: #000000;
      border-radius: 2px;
      color: #ffffff;
      font-size: 15px;
      animation: show-tips .5s;
      @keyframes show-tips {
          0% { 
              opacity: 0;
              top: -64px
          }
          100% {
              opacity: 0.6;
              top: 14px
          }
      }
      span {
          width: 42px;
          height: 28px;
          border: 1px solid #f0f1f5;
          border-radius: 3px;
          text-align: center;
          line-height: 28px;
          margin: 0 5px;
      }
  }
  // marginc-box图标
  .bk-icon {
    font-family: 'bk-icons-linear' !important;
  }
  .public-pop {
      padding: 10px !important;
      width: 130px;
      min-width: 120px;
      height: 170px;
      text-align: center;
      .qr-code {
          width: 110px;
          height: 110px;
          margin-bottom: 5px;
      }
      p {
          color: #63656e;
          line-height: 17px;
          font-size: 12px;
      }
  }
</style>

<style media="screen" lang="scss" scoped>
  .wrapper{
    height: 100%;
    min-width: 1180px;
  }
  .bk-content {
    background-color: #f5f7fa;
    min-height: calc(100% - 320px);
    overflow: hidden;
  }
  .qd-fixed-wrapper {
      position: fixed;
      right: 20px;
      top: 400px;
      z-index: 9999;
      .operate-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          width: 52px;
          // height: 263px;
          background: #ffffff;
          border-radius: 26px;
          box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.10);
          margin-bottom: 22px;
          padding-top: 18px;
          .operate-btn {
              font-size: 12px;
              margin-bottom: 20px;
              cursor: pointer;
              text-align: center;
              color: #979ba5;
              img {
                  width: 16px;
                  height: 15px;
                  margin-bottom: 4px;
              }
              .doc-icon {
                  height: 16px;
                  width: 16px;
                  display: inline-block;
                  margin-bottom: 4px;
                  &::after {
                      content: '';
                      height: 16px;
                      width: 16px;
                      position: absolute;
                      z-index: 1;
                      display: none;
                  }
              }
              .icon-help {
                  height: 14px;
                  width: 14px;
                  background: url('./images/video/help.png');
                  background-size: 100% 100%;
                  &::after {
                    height: 14px;
                    width: 14px;
                      background: url('./images/video/help1.png');
                      background-size: 100% 100%;
                  }
              }
              .icon-comment {
                  height: 18px;
                  width: 18px;
                  background: url('./images/video/comment.png');
                  background-size: 100% 100%;
                  &::after {
                      height: 18px;
                      width: 18px;
                      background: url('./images/video/comment1.png');
                      background-size: 100% 100%;
                  }
              }
              .icon-qq-i {
                  background: url('./images/video/qq.png');
                  background-size: 100% 100%;
                  &::after {
                      background: url('./images/video/qq1.png');
                      background-size: 100% 100%;
                  }
              }
              .icon-qr-code {
                  background: url('./images/video/qr-code.png');
                  background-size: 100% 100%;
                  &::after {
                      background: url('./images/video/qr-code1.png');
                      background-size: 100% 100%;
                  }
              }
              &:hover {
                  color: #3a84ff;
                  .doc-icon::after {
                      display: block;
                      z-index: 3;
                  }
              }
          }
      }
  }
</style>



// WEBPACK FOOTER //
// app.vue?13c803d3